export default __webpack_public_path__ + "static/media/balloon5.f0f17827.png";